import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconErrorCircleFilled16 = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	viewBox: "0 0 16 16",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14m-.75-6V4h1.5v5zm0 3v-1.5h1.5V12z",
		clipRule: "evenodd"
	})
});
const ForwardRef = forwardRef(SvgIconErrorCircleFilled16);
export default ForwardRef;
